import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { Redirect, withRouter, useHistory  } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";


import { useSelector, useDispatch } from "react-redux";
import { logoutUser } from "../../store/actions";

import ApiClient from "../../FindagramAdmin/BaseUrl/ApiClient";

const Logout = (props) => {
  const dispatch = useDispatch();
  const history = useHistory();
      const [loading, setLoading] = useState(false);

  const { isUserLogout } = useSelector((state) => ({
    isUserLogout: state.Login.isUserLogout,
  }));

useEffect(() => {
    const handleLogout = async () => {
      try {
        const accessToken = localStorage.getItem("accessToken");

        if (!accessToken) {
          toast.error("No access token found. Please log in again.");
          // Clear all localStorage items even if no token
          localStorage.removeItem("accessToken");
          localStorage.removeItem("refreshToken");
          localStorage.removeItem("authUser");
          localStorage.removeItem("subscriptionType");
          localStorage.removeItem("subscriptionStatus");
          localStorage.removeItem("subscriptionExpiryDate");
          localStorage.removeItem("businessId");
          localStorage.removeItem("redirectAfterSubscribe");
          localStorage.removeItem("instagramData");
          localStorage.removeItem("user");
          return;
        }

        await ApiClient().delete("/auth/logout", {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        });

        // Clear all authentication and user data
        localStorage.removeItem("accessToken");
        localStorage.removeItem("refreshToken");
        localStorage.removeItem("authUser");
        localStorage.removeItem("subscriptionType");
        localStorage.removeItem("subscriptionStatus");
        localStorage.removeItem("subscriptionExpiryDate");
        localStorage.removeItem("businessId");
        localStorage.removeItem("redirectAfterSubscribe");
        localStorage.removeItem("instagramData");
        localStorage.removeItem("user"); // From fake backend
        toast.success("Logged out successfully");

        // Redirect to /login after 1.5 seconds
        setTimeout(() => {
          history.push("/login"); // For React Router v5
          // navigate("/login"); // For React Router v6
        }, 1500);

      } catch (error) {
        // Clear localStorage even if API call fails
        localStorage.removeItem("accessToken");
        localStorage.removeItem("refreshToken");
        localStorage.removeItem("authUser");
        localStorage.removeItem("subscriptionType");
        localStorage.removeItem("subscriptionStatus");
        localStorage.removeItem("subscriptionExpiryDate");
        localStorage.removeItem("businessId");
        localStorage.removeItem("redirectAfterSubscribe");
        localStorage.removeItem("instagramData");
        localStorage.removeItem("user");
        
        (error?.response?.data?.responseMessage || ["Logout failed"]).forEach((msg) => {
          toast.error(msg);
        });
      } finally {
        setLoading(false);
      }
    };

    handleLogout();
  }, [history]); 



  if (isUserLogout) {
    return <Redirect to="/login" />;
  }

  return <></>;
};

Logout.propTypes = {
  history: PropTypes.object,
};

export default withRouter(Logout);